import React, { Component } from 'react';
import PropTypes from 'prop-types';
import css from './index.scss';
import Checkbox from '../checkbox';

class SelectableListItem extends Component {
  constructor(props) {
    super(props);
    const { checked } = props;
    this.state = {
      checked
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checked !== this.props.checked) {
      this.setState({ checked: nextProps.checked });
    }
  }
    onSelection = (cbState, id) => {
      const checked = cbState === 'checked';
      this.setState({ checked });
      this.props.onChange(id, checked);
    };

    render() {
      const { id, name } = this.props;
      return (
        <div key={id}>
          <div className={css.info}>
            <div className={css.checkbox}>
              <Checkbox
                state={this.state.checked}
                checkboxHandler={(cbState, cbId) => this.onSelection(cbState, cbId)}
                id={id.toString()} />
              <span className={css.description}>{name}</span>
            </div>
          </div>
        </div>
      );
    }
}

SelectableListItem.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  name: PropTypes.string,
  checked: PropTypes.string,
  onChange: PropTypes.func
};

export default SelectableListItem;
